import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-http-backend';
import Cache from 'i18next-localstorage-cache';
import LanguageDetector from 'i18next-browser-languagedetector';

import { defaultLocale } from './config';

const debug = process.env.NODE_ENV === 'development';

i18n
  .use(Backend)
  .use(Cache)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json?n=${new Date().getTime()}`,
    },
    cache: {
      enabled: true,
    },
    debug,
    lng: defaultLocale,
    supportedLngs: ['en-GB', 'en-US', 'en', 'fi'],
    fallbackLng: defaultLocale,
    // have a common namespace used around the full app
    ns: ['account', 'dashboard', 'homepage', 'timeFormat', 'activities'],
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      useSuspense: true,
    },
  }, (err, t) => {
    if (err) {
      if (debug) {
        console.error('Error loading localizations', err);
      }
    }
  });

export default i18n;
